
class Theme
{
    /**
     * base color
     * @type {string}
     */
    BaseColor = "#000000";
    /**
     * path to main logo (login)
     * @type {string}
     */
    LogoPath = "";
    /**
     * html color hex
     * @type {string}
     */
    LoginBackgroundColor = "#000000";
    /**
     * html color hex
     * @type {string}
     */
    StartTextColor = "";

    Slide1 = "";

    Slide2 = "";

    Slide3 = "";

    constructor()
    {
        let name = "";

        let designs = require('./designs/designs.json');
        let designCollection = designs.Designs;

        if( localStorage.getItem("vas_design"))
        {
            name = localStorage.getItem("vas_design");
        }
        else
        {
            if(designCollection.length > 0 )
                {name = designCollection[0]["Name"];}
        }
        let me = this;
        designCollection.forEach(function (currentElement, /*currentIndex, referenceToArray*/)
        {
            if(currentElement["Name"] === name)
            {
                let design  = require('./designs/' + currentElement["Path"]);
                me.BaseColor = design["ThemeMainColor"];
                me.LogoPath = design["LogoPathWithName"];
                me.LoginBackgroundColor = design["LoginBackgroundColor"];
                me.StartTextColor = design["StartTextColor"];
                me.Slide1 = design["Slide1"];
                me.Slide2 = design["Slide2"];
                me.Slide3 = design["Slide3"];

            }
        });
    }
}
export default Theme;